<template>
  <div>
    <el-row class="alignSelf" :gutter="6" style="padding: 9px 0 13px 17px">
      <el-col class="alignSelf" :span="0.5"><img src="../../../assets/img/pages/ru.png" height="26" width="26"/></el-col>
      <el-col style="display: flex">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="align-items: center;display: flex;align-items: center;">
          <el-breadcrumb-item style="color: #2F374B;font-size: 18px">产品原型设计工具</el-breadcrumb-item>
          <el-breadcrumb-item v-if="isNew" style="color: #2F374B;font-size: 18px">我刚新建的目录</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <div style="padding: 7px 0 13px 17px;display: flex;">
      <el-button class="buttonClass" @click="goToAddMajor">
        <i class="el-icon-circle-plus buttonIconClass">
          <span class="buttonNameClass">场景</span>
        </i>
      </el-button>
      <el-button v-show="!isNew" class="buttonClass" @click="addCatalogueDialog=true">
        <i class="el-icon-circle-plus buttonIconClass">
          <span class="buttonNameClass">目录</span>
        </i>
      </el-button>
      <div style="float: right;width: 100%">
        <div style="float: right;font-size: 14px;color: #2F374B">
          <el-input
              v-model="catalogueNameSearch"
              type="text"
              prefix-icon="el-icon-search"
              placeholder="请输入关键词"
              style="width: 270px; cursor: pointer"
              clearable
          ></el-input>
          <div style="float: right;padding: 0 29px 0 10px">
        <el-button style="color: #fff;background-color: #4d78ff;border-color: #4d78ff;width: 70px;height: 40px" @click="selectDirectoryList">
          搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-row style="padding: 20px 0 0 17px" :gutter="20">
      <el-col v-for="(item,index) in list" :key="index" style="padding-bottom: 10px;width: 270px;">
        <el-card :body-style="{ padding: '10px' }" style="width: 250px;">
          <img v-if="item.type === '0'" :src="item.logoUrl ? item.logoUrl : 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene.png'" class="image" alt="" @click="goDetails(item)"/>
          <img v-if="item.type === '1'" :src="item.logoUrl ? item.logoUrl : 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/catalogue.png'" class="image" alt="" @click="goDetails(item)"/>
          <div style="margin-top: 10px">
            <div style="display: flex">
              <div class="cardName" @click="goDetails(item)">
                <div v-html="item.keyword ? item.keyword : item.name"> </div>
              </div>
              <div v-if="item.type == '0'" class="dropdownDiv">
              <el-dropdown placement="top-end" style="position: absolute;right: 0px;">
                <div style="font-size: 21px;cursor: pointer">
                  <img src="../../../assets/img/pages/she.png" height="22" width="22"/></div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" style="color: #2F374B" @click.native="cataloguePropertiesView(item)">属性</el-dropdown-item>
                  <el-dropdown-item command="b" style="color: #2F374B" @click.native="clone(item.id)">克隆</el-dropdown-item>
                  <el-dropdown-item command="c" style="color: #2F374B" @click.native="changeMoveCatalogueDialogVisible(item)">移动到目录</el-dropdown-item>
                  <el-dropdown-item command="d" style="color: #FF0000" @click.native="isDelect(item)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              </div>
              <div v-if="item.type == '1'" class="dropdownDiv">
              <el-dropdown placement="top-end" style="position: absolute;right: 0px;">
                <div style="font-size: 21px;cursor: pointer">
                  <img src="../../../assets/img/pages/she.png" height="22" width="22"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" style="color: #2F374B" @click.native="cataloguePropertiesView1(item)">属性</el-dropdown-item>
                  <el-dropdown-item command="d" style="color: #FF0000" @click.native="isDirectory(item)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              </div>
            </div>
            <div class="bottom clearfix">
              <icon class="el-icon-time" style="font-size: 14px"></icon>
              <time class="time">上次修改:{{item.updateTimeVo }}</time>
            </div>
            <div style="margin-top: 10px;justify-content: space-between;display: flex;height:30px;position: relative;">
              <div v-if="item.type == '0'">
                <div v-if="item.sceneStatus == '0'" class="pointClass">
                  开发中
                </div>
                <div v-if="item.stageStatus == '10'" class="pointClass">
                  车辆测试-等待测试
                </div>
                <div v-if="item.stageStatus == '11'" class="pointClass">
                  车辆测试-测试中
                </div>
                <div v-if="item.stageStatus == '12'" class="pointClass">
                  车辆测试-测试通过
                </div>
                <div v-if="item.stageStatus == '13'" class="pointClass">
                  车辆测试-测试不通过
                </div>
                <div v-if="item.stageStatus == '20'" class="pointClass">
                  等待发布
                </div>
                <div v-if="item.stageStatus == '21'" class="pointClass">
                  发布-通过
                </div>
                <div v-if="item.stageStatus == '22'" class="pointClass">
                  发布-不通过
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <div v-if="list.length < 1" style="width: 100%;height: 600px;display: flex;align-items: center;justify-content: center;">
        <img src="../../../assets/img/pages/nodata.png" height="300" width="300"/></div>
    </el-row>
    <el-dialog
        :visible.sync="addCatalogueDialog"
        top="200px"
        width="860px"
        center
        :before-close="handleClose"
    >
      <div style="width: 100%;height: 50px;text-align: center;letter-spacing: 1px;">
        <span style="font-size: 18px;color: #2F374B;">新建目录</span>
      </div>
      <el-form ref="catalogueForm" :model="catalogueForm" :rules="catalogueRules">
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="目录名称：" style="display: inline-flex;" prop="catalogueName">
              <el-input v-model="catalogueForm.catalogueName" style="width: 246px;" maxlength="20" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 41px">
          <el-col style="text-align: center">
            <el-button type="primary" class="confirmButton" round @click="submitCatalogue('catalogueForm')">确 定</el-button>
            <el-button class="cancelButton" round @click="cancelCatalogue()">取 消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
        v-if="list.length > 0"
        title=""
        :visible.sync="dialogVisible"
        top="200px"
        width="860px"
        center>
      <div style="width: 100%;height: 50px;text-align: center;letter-spacing: 1px;">
        <span style="font-size: 18px;color: #2F374B;">属性</span>
      </div>
      <el-form ref="catalogueUpdateForm" :model="catalogueProperties" :rules="catalogueUpdateFormRules1" label-width="">
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="场景名称：" style="display: inline-flex;" prop="newName">
              <el-input  v-model="catalogueProperties.newName" style="width: 246px;" maxlength="20" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="场景分类：" style="display: inline-flex;">
              <el-select v-model="label" clearable placeholder="未分类" style="width: 246px">
                <el-option
                    v-for="item in options"
                    :key="item.tagId"
                    :label="item.tagName"
                    :value="item.tagName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="场景介绍：" style="display: inline-flex;" prop="newDescribes">
              <el-input
                  v-model="catalogueProperties.newDescribes"
                  maxlength="500"
                  resize="none"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  style="width: 246px">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="场景图标：" style="display: inline-flex;padding-left: 240px;white-space:nowrap;">
              <div style="display:flex;width: 506px">
                <el-upload
                    :limit="1"
                    :before-upload="beforeUpload"
                    list-type="picture-card"
                    action=""
                    :http-request="cutomUpload"
                    :file-list="fileList"
                    :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="catalogueProperties.newLogoUrl">
                    <span class="el-upload-list__item-actions">
                      <!-- <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span> -->
                      <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="uploadDialogVisible">
                  <img width="100%" :src="dialogImageUrl">
                </el-dialog>
              </div>
              <div style="font-size: 12px;text-align: left;line-height: 20px;">
                <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 41px">
          <el-col style="text-align: center">
            <el-button type="primary" class="confirmButton" round @click="addOrUpdateScene('catalogueUpdateForm')">确 定</el-button>
            <el-button class="cancelButton" round @click="cancelCatalogueUpdate()">取 消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
        v-if="list.length > 0"
        title=""
        :visible.sync="movCatalogueDialogVisible"
        :before-close="handleClose"
        width="45%"
        center>
      <div style="text-align:center;">
        <div class="allDirectoryHeader">
          <span style="font-size: 18px;font-weight: 400;color: #000000">将场景</span>
          <span class="directoryName" :title="catalogueFrom.name">{{catalogueFrom.name}}</span>
          <span style="font-size: 18px;font-weight: 400;color: #000000">移动至目录</span>
        </div>
        <div class="moveDialogDiv">
          <el-radio-group v-model="catalogueFrom.catalogueRadio" style="padding:22px;display: grid;" @change="updateCatalogueDialog">
            <el-radio v-for="(catalogueItem,catalogueIndex) in list1" :key="catalogueIndex" style="padding-top:10px" :label="catalogueItem.id" >{{catalogueItem.catalogueName}}</el-radio>
          </el-radio-group>
        </div>
        <el-button type="primary" class="confirmButton" round @click="determineMoveCatalogue()">确 定</el-button>
        <el-button class="cancelButton" round  @click="cancelMoveCatalogue()">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="dialogVisible3"
        top="200px"
        width="860px"
        :before-close="handleClose"
        center>
      <div style="width: 100%;height: 50px;text-align: center;letter-spacing: 1px;">
        <span style="font-size: 18px;color: #2F374B;">属性</span>
      </div>
      <el-form ref="catalogueUpdateForm1" :model="catalogueProperties" :rules="catalogueUpdateFormRules" label-width="">
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="目录名称：" style="display: inline-flex;" prop="newName">
              <el-input  v-model="catalogueProperties.newName" style="width: 246px;" maxlength="20" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="目录介绍：" style="display: inline-flex;" prop="newDescribes">
              <el-input
                  v-model="catalogueProperties.newDescribes"
                  maxlength="500"
                  resize="none"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入内容"
                  style="width: 246px">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="text-align: center">
            <el-form-item label="场景图标：" style="display: inline-flex;padding-left: 240px;white-space:nowrap;">
              <div style="display:flex;width: 506px">
                <el-upload
                    :limit="1"
                    :before-upload="beforeUpload"
                    list-type="picture-card"
                    action=""
                    :http-request="cutomUpload"
                    :file-list="fileList"
                    :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="catalogueProperties.newLogoUrl">
                    <span class="el-upload-list__item-actions">
                      <!-- <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span> -->
                      <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="uploadDialogVisible" style="z-index: 10000000">
                  <img width="100%" :src="dialogImageUrl">
                </el-dialog>
              </div>
              <div style="font-size: 12px;text-align: left;line-height: 20px;">
                <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-top: 41px">
          <el-col style="text-align: center">
            <el-button type="primary" class="confirmButton" round @click="updateCatalogue('catalogueUpdateForm1')">确 定</el-button>
            <el-button class="cancelButton" round @click="cancelCatalogueUpdate1()">取 消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { delScene, selectDirectoryList, cloneScene, addOrUpdateScene, addOrUpdateDirectory, delDirectory, selectDirectoryAllList, selectDirectoryColumn, sceneMove } from '@/api/modules/beginner'
import { getUploadKey } from '@/api/modules/api'
import { getLabel } from '@/api/modules/forum'
import COS from 'cos-js-sdk-v5'
export default {
  name: 'Beginner',
  data() {
    const validateInputSpecialKey = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符！！'))
      }
      else {
        callback()
      }
    }
    return {
      options: [],
      // errorImg: '',
      isNew: false,
      show: false,
      show3: true,
      formLabelWidth: '58px',
      movCatalogueDialogVisible: false,
      dialogVisible: false,
      dialogVisible3: false,
      radio: '1',
      addCatalogueDialog: false,
      moveDirectoryDialogVisible: false,
      currentDate: new Date(),
      list: [],
      selectIndex: 0,
      input: '',
      fileList: [],
      list1: [],
      catalogueNameSearch: '',
      details: {},
      label: '',
      items: [
        { name: '1', time: '2020-12-05', point: 1 },
        { name: '2', time: '2020-12-05', point: 2 },
        { name: '3', time: '2020-12-05', point: 3 },
        { name: '4', time: '2020-12-05', point: 5 }
      ],
      catalogueFrom: {
        id: '',
        name: '',
        catalogueRadio: ''
      },
      catalogueProperties: {
        id: '',
        newName: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      },
      catalogueForm: {
        catalogueName: ''
      },
      catalogueRules: {
        catalogueName: [
          { required: true, message: '请输入目录名称', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'blur' }
        ]

      },
      catalogueUpdateForm: {
        newName: ''
      },
      catalogueUpdateForm1: {
        newName: ''
      },
      catalogueUpdateFormRules: {
        newName: [
          { required: true, message: '请输入目录名称', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'blur' }
        ], newDescribes: [
          { message: '请输入目录介绍', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'change' }
        ]
      },
      catalogueUpdateFormRules1: {
        newName: [
          { required: true, message: '请输入场景名称', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'blur' }
        ], newDescribes: [
          { message: '请输入目录介绍', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'change' }
        ]
      },
      tabList: [],
      dialogImageUrl: '',
      uploadDialogVisible: false,
      disabled: false
    }
  },
  watch: {
    addCatalogueDialog(newVal, oldVal) {
      this.catalogueForm.catalogueName = '我刚建的目录'
    }
  },
  created() {
    this.selectDirectoryList()
    this.getLabel()
    // this.selectDirectoryAllList()
  },
  methods: {
    cancelCatalogue() {
      this.$refs.catalogueForm.clearValidate()
      this.addCatalogueDialog = false
    },
    // 移动目录操作
    async determineMoveCatalogue() {
      const res = await sceneMove({ id: this.catalogueFrom.id, catalogueId: this.catalogueFrom.catalogueRadio })
      if (res.code === 0) {
        this.$message({
          message: '移动成功！',
          type: 'success'
        })
        this.moveCatalogue()
        await this.selectDirectoryList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 取消移动目录操作
    cancelMoveCatalogue() {
      this.moveCatalogue()
    },
    moveCatalogue() {
      this.catalogueFrom.id = ''
      this.catalogueFrom.catalogueRadio = ''
      this.catalogueFrom.name = ''
      this.movCatalogueDialogVisible = false
    },
    // 查询目录列
    changeMoveCatalogueDialogVisible(item) {
      this.catalogueFrom.id = item.id
      this.catalogueFrom.name = item.name
      this.movCatalogueDialogVisible = true
      this.selectDirectoryColumn()
    },
    updateCatalogueDialog(e) {
      this.catalogueFrom.catalogueRadio = e
    },
    async selectDirectoryColumn() {
      const data = {
        userId: '144300110000000002'
      }
      const res = await selectDirectoryColumn(data)
      if (res.code === 0) {
        this.list1 = res.data
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 目录列表
    async selectDirectoryAllList(id = '') {
      const data = {
        id: id
      }
      const res = await selectDirectoryAllList(data)
      if (res.code === 0) {
        this.list = res.data
        // this.list = []
        console.log(this.list)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async updateCatalogueSubmit() {
      const catalogueProperties = this.catalogueProperties
      const res = await addOrUpdateDirectory({
        id: catalogueProperties.id,
        catalogueName: catalogueProperties.newName,
        catalogueDesc: catalogueProperties.newDescribes,
        logoKey: catalogueProperties.newLogoKey,
        logoUrl: catalogueProperties.newLogoUrl,
        uesType: 1
      })
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.cancelCatalogueUpdate1()
        this.selectDirectoryList()
        // this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    updateCatalogue(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateCatalogueSubmit()
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async addOrUpdateSceneSubmit() {
      const catalogueProperties = this.catalogueProperties
      const res = await addOrUpdateScene({
        sceneType: this.label,
        id: catalogueProperties.id,
        catalogueName: catalogueProperties.newName,
        sceneName: catalogueProperties.newName,
        catalogueDesc: catalogueProperties.newDescribes,
        sceneDesc: catalogueProperties.newDescribes,
        logoKey: catalogueProperties.newLogoKey,
        logoUrl: catalogueProperties.newLogoUrl,
        uesType: 1
      })
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.cancelCatalogueUpdate()
        this.selectDirectoryList()
        // this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 更改场景
    addOrUpdateScene(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrUpdateSceneSubmit()
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelCatalogueUpdate() {
      this.fileList = []
      this.label = []
      this.catalogueProperties = {
        id: '',
        type: '',
        newName: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      }
      this.dialogVisible = false
    },
    cancelCatalogueUpdate1() {
      this.fileList = []
      this.catalogueProperties = {
        id: '',
        type: '',
        newName: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      }
      this.dialogVisible3 = false
    },
    // 全部列表
    async selectDirectoryList() {
      const data = {
        userId: '144300110000000002',
        catalogueName: this.catalogueNameSearch
      }
      const res = await selectDirectoryList(data)
      console.log(res.data.records)
      if (res.code === 0) {
        // const msg = this.catalogueNameSearch === '' ? '没有数据！' : '未搜索到相关内容！'
        this.list = res.data
      }
    },
    // 全部创建目录
    submitCatalogue(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrUpdateDirectory(this.catalogueForm, 0)
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async addOrUpdateDirectory(data, flag) {
      const param = data
      param.uesType = flag
      const res = await addOrUpdateDirectory(param)
      console.log(res.code)
      if (res.code === 0) {
        if (flag === 0) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
        }
        else {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        }

        await this.selectDirectoryList()
        this.addCatalogueDialog = false
      }
      else {
        if (res.code !== 113) {
          this.catalogueForm = ''
        }
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 克隆
    async clone(id) {
      await this.$confirm('是否克隆当前场景？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        confirmButtonClass: 'confirmButtonClass',
        cancelButtonClass: 'cancelButtonClass',
        closeOnClickModal: false
      })
        .then(() => {
          this.cloneScene(id)
        })
      await this.selectDirectoryList()
        .catch(action => {
          this.$message({
            type: 'info',
            message: action === 'cancel'
              ? '放弃保存并离开页面'
              : '停留在当前页面'
          })
        })
    },
    async cloneScene(id) {
      const data = {
        id: id
      }
      const res = await cloneScene(data)
      if (res.code === 0) {
        this.$message({
          message: '克隆成功',
          type: 'success'
        })
        await this.selectDirectoryList()
      }
      else {
        this.$message({
          message: '克隆失败',
          type: 'error'
        })
      }
    },
    // 场景删除
    async delScene(id) {
      const data = {
        id: id
      }
      const res = await delScene(data)
      if (res.code === 0) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        await this.selectDirectoryList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 目录删除
    async delDirectory(id) {
      const data = {
        id: id
      }
      const res = await delDirectory(data)
      if (res.code === 0) {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        await this.selectDirectoryList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    handleRemove(file) {
      this.catalogueProperties.newLogoKey = ''
      this.catalogueProperties.newLogoUrl = ''
      this.fileList = []
      console.log(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.uploadDialogVisible = true
    },
    handleClose() {
    },
    goDetails(data) {
      console.log(data)
      if (data.type === '1') {
        // this.list1 = data.data
        this.$router.push({ path: '/article/directory', query: { id: data.id, name: this.catalogueNameSearch }})
        this.selectDirectoryAllList(data.id)
        this.isNew = !this.isNew
      }
      else {
        this.$router.push({
          path: '/beginner/editor',
          query: { id: data.id }
        })
      }
    },
    // handleClose(done) {
    //   this.dialogVisible = false
    //   this.dialogVisible1 = false
    // },
    cataloguePropertiesView(item) {
      this.label = item.sceneType
      this.dialogVisible = true
      this.catalogueProperties.id = item.id
      this.catalogueProperties.newName = item.name
      this.catalogueProperties.type = item.type
      this.catalogueProperties.newDescribes = item.describes
      if (item.logoUrl !== '' && item.logoUrl !== null) {
        this.catalogueProperties.newLogoKey = item.logoKey
        this.catalogueProperties.newLogoUrl = item.logoUrl
        this.fileList = [{ name: item.logoUrl, url: item.logoUrl }]
      }
    },
    cataloguePropertiesView1(item) {
      this.dialogVisible3 = true
      this.catalogueProperties.id = item.id
      this.catalogueProperties.newName = item.name
      this.catalogueProperties.type = item.type
      this.catalogueProperties.newDescribes = item.describes
      if (item.logoUrl !== '' && item.logoUrl !== null) {
        this.catalogueProperties.newLogoKey = item.logoKey
        this.catalogueProperties.newLogoUrl = item.logoUrl
        this.fileList = [{ name: item.logoUrl, url: item.logoUrl }]
      }
    },
    beforeUpload(file) {
      this.addResource = file
      this.fileName = file.name
      console.log(file)
      if (this.addResource.type === 'image/png' || this.addResource.type === 'image/jpg' || this.addResource.type === 'image/jpeg') {
        if (file.size < 500 * 1024) {
          this.fileList = []
          this.$message.success('正在上传')
          return true
        }
        else {
          this.$message.error('图片大小不能超过500kb')
          return false
        }
      }
      this.$message.error('文件格式有误')
      return false
    },
    async cutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.catalogueProperties.newLogoKey = key
        this.catalogueProperties.newLogoUrl = 'http://' + data.Location
        this.fileList = [{ name: file.name, url: 'http://' + data.Location }]
        console.log(this.list)
        console.log(err || data)
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    changeMoveDirectoryDialogVisible(index) {
      this.selectIndex = index
      this.moveDirectoryDialogVisible = true
    },
    change4(index) {
      this.selectIndex = index
      const list = {}
      Object.assign(list, this.list[index])
      this.catalogueUpdateForm = list
      this.dialogVisible3 = true
    },
    isDirectory(item) {
      this.$confirm('是否删除当前目录？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        confirmButtonClass: 'confirmButtonClass',
        cancelButtonClass: 'cancelButtonClass',
        closeOnClickModal: false
      })
        .then(() => {
          this.delDirectory(item.id)
        })
    },
    isDelect(item) {
      this.$confirm('是否删除当前信息？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        confirmButtonClass: 'confirmButtonClass',
        cancelButtonClass: 'cancelButtonClass',
        closeOnClickModal: false
      })
        .then(() => {
          this.delScene(item.id)
        })
    },
    goToAddMajor(data) {
      this.$router.push({
        path: '/beginner/editor'
      })
    },
    goBackList() {
      // this.list1 = this.list
      this.selectDirectoryList()
      this.isNew = !this.isNew
    },
    async getLabel() {
      const data = {
        status: 1,
        tagGroupId: '1040925626048364544',
        pageSize: 1000
      }
      const res = await getLabel(data)
      if (res.code === 0) {
        this.options = res.data.dataList
      }
    },
    checkSpecialKey(str) {
      if (typeof str !== 'undefined' && str != null && str !== '') {
        const specialKey =
    "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
        for (let i = 0; i < str.length; i++) {
          if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.time {
  padding-left: 1px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.bottom {
  margin-top: 10px;
}
.button {
  padding: 0;
  float: right;
}
.allDirectoryHeader{
  padding-bottom: 23px;
  width: 100%;
  height: 50px;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-content: space-between;
}
.directoryName{
  font-size: 24px;
  color: rgb(77, 120, 255);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 27%;
  display: block;
}
.image {
  width: 100%;
  height: 151px;
  display: block;
  border-radius: 4px;
}
.el-input__inner1 {
  width: 15vw;
}
.el-input__inner2 {
  width: 15vw;
  height: 20vh;
}
.el-card {
  height: 272px;
  transition: all .5s;
}
.el-card:hover {
  border:1px solid #4d78ff;
}
.alignSelf {
  align-self: center;
  display: flex;
}
.buttonClass {
  color: #4d78ff;
  border-radius: 4px;
  border:1px solid #4d78ff;
  height: 58px;
  font-size: 16px;
  align-items: center;
  display: flex;
  align-self: center;
}
.goBackButton{
  color: #ffffff;
  border-radius: 4px;
  border:1px solid #4d78ff;
  height: 58px;
  font-size: 18px;
  align-items: center;
  display: flex;
  background-color: #4d78ff
}
.pointClass {
  border-radius: 13px;
  border:1px solid #4D78FF;
  padding: 5px 11px;
  font-size: 14px;
  color: #4D78FF;
  background-color: #EEF7FF;
}
.waitTestClass {
  border-radius: 13px;
  border:1px solid #DDDDDD;
  padding: 5px 11px;
  font-size: 14px;
  color: #A2A2A2;
  background-color: #F5F6F8;
}
.confirmButton{
  color: #fff;
  background-color: #4d78ff;
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.cancelButton{
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.buttonNameClass{
  display: flex;
  align-self: center;
  font-size: 16px;
  padding-left:9px;
}
.buttonIconClass{
  font-size: 22px;
  display: flex;
  align-items: center;
}
::v-deep .el-dialog__headerbtn{
  display:none;
}
.dialog-header{
  padding-top: 50px;
}
.titleClass{
  font-size: 14px;
  font-weight: 400;
  color: #2F374B;
}
.moveDialogDiv:hover{
  overflow-y: scroll;
}
.moveDialogDiv{
  overflow: hidden;
  width: 365px;
  height: 300px;
  background: #FFFFFF;
  border: 1px solid #4d78ff;
  border-radius: 4px;
  text-align: left;
  margin: 0 auto 33px;
  white-space: nowrap;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: rgb(220 225 225 / 65%);
  cursor: pointer;
  border-radius: 4px;
}
::v-deep .el-dropdown-menu{
  padding: 3px 0 !important;
  background: #4D78FF
}
::v-deep .el-upload-list__item{
  width:80px;
  height:80px;
}
::v-deep .el-upload--picture-card{
  width:80px;
  height:80px;
  line-height:86px;
}
.cardName {
  width: 200px;
  height: 19px;
  display:block;
  color: #2F374B;
  font-size: 16px;
  /*display: flex;*/
  /*align-items: center;*/
  padding: 0 6px;
}
.cardName > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdownDiv{
  justify-content: space-between;
  display: flex;
  width: 21px;
  height:20px;
  position: relative;
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
   width: 16px;
   height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
.v-modal{
  z-index: 2002 !important;
}
</style>
